import { render, staticRenderFns } from "./AppControls.vue?vue&type=template&id=7f4a8ad9&scoped=true"
import script from "./AppControls.vue?vue&type=script&setup=true&lang=js"
export * from "./AppControls.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AppControls.vue?vue&type=style&index=0&id=7f4a8ad9&prod&scoped=true&lang=css"
import style1 from "./AppControls.vue?vue&type=style&index=1&id=7f4a8ad9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4a8ad9",
  null
  
)

export default component.exports